import { el, setChildren } from 'redom';
import { Node } from 'slate';
import { ReactEditor } from 'slate-react';
import { nanoid } from 'nanoid';

import application from 'application';

import { stringToSVG } from 'utilities';
import {
  convertToOptionsCollection
} from 'utilities/collection';

import SimpleMenu from 'generics/components/simple-menu';

import { getExportOptions, exportTypes } from './utilities';

import './index.scss';

import exportIconString from 'assets/images/export-icon.svg?raw';

const exportIcon = stringToSVG(exportIconString);

class ShapesMenuPrimaryView {

  constructor(name) {

    this.el = el('p.shape-options-button-primary-view', [
      exportIcon.cloneNode(true),
      el('span', name)
    ]);

  }

}

class ItemView {

  constructor(list) {

    this.list = list;
    this.option = null;
    this.label = el('span.menu-option-label');
    this.el = el('span.menu-option-item', {
      onclick: this.handleClick.bind(this)
    });

  }

  handleClick(event) {

    event.stopPropagation();
    event.preventDefault();

    return this.list.onSelect(event, this.option);

  }

  update(option) {

    this.option = option;

    this.label.textContent = option.label;

    const children = [this.label];

    setChildren(this.el, children);

  }

}

class CanvasShapesPanel {

  constructor(configuration) {

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;

    this.menu = new SimpleMenu({
      id: 'canvas-export-menu',
      name: 'Export to',
      PrimaryContentView: ShapesMenuPrimaryView,
      optionsDisplaySide: 'right',
      options: convertToOptionsCollection(getExportOptions(), 'name', 'type'),
      ItemView
    });

    this.menu.registerClickEvent(this.handleExportTypeSelect.bind(this));

    this.el = el('button#canvas-export-options-button', [this.menu]);

  }

  handleExportTypeSelect(event, option) {

    const object = option.object;

    if (object.type === exportTypes.WEBM) {
      this.exportToWebM(event);
    } else if (object.type === exportTypes.MP4) {
      this.exportToMP4(event);
    }

  }

  getVideoBuilder() {

    const canvasNode = Node.get(this.editor, this.activeNodePath);
    const domNode = ReactEditor.toDOMNode(this.editor, canvasNode);

    return domNode.querySelector('.canvas-container').videoBuilder;

  }

  exportToWebM(event) {

    event.stopPropagation();

    const builder = this.getVideoBuilder();

    builder.exportToWebM();

  }

  exportToMP4(event) {

    event.stopPropagation();

    const builder = this.getVideoBuilder();

    builder.exportToMP4();

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;

  }

}

export default CanvasShapesPanel;